import { render, staticRenderFns } from "./UsersAndCategoriesTab.vue?vue&type=template&id=53ecabf8"
import script from "./UsersAndCategoriesTab.vue?vue&type=script&lang=js"
export * from "./UsersAndCategoriesTab.vue?vue&type=script&lang=js"
import style0 from "./UsersAndCategoriesTab.vue?vue&type=style&index=0&id=53ecabf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports